import {Injectable} from '@angular/core';
import {ApiService} from "../../../services/api/api.service";

@Injectable({
  providedIn: 'root'
})
export class AuthDataService {

  constructor(
    private apiService: ApiService
  ) {
  }

  sendRequestRecoveryPassword(email: string) {
    const url = `/send_email?email=${email}`
    return this.apiService.httpGet(url)
  }

  setNewPassword(token: string, data: SetNewPasswordDto) {
    const url = `/reset_password/update?expiryToken=${token}`
    return this.apiService.httpPost(url, data)
  }
}
